module.exports = __webpack_public_path__ + "img/NewIcon.327d6d5f.png";